export const eventTypes = {
    BATCH: "submissions.ModerationPhotoBatch",
    UPLOAD: "submissions.PhotoUpload",
    MODERATION: "submissions.PhotoUploadModerationNote",
    BATCH_MODERATION_NOTE: "submissions.PhotoBatchModerationNote",
    BATCH_PHOTO_COUNT: "submissions.ModerationPhotoBatchPhotoCounts"
};

export const eventActions = {
    UPDATE: "update",
    CLAIMED_BATCH: "claimed batch",
    RELEASED_CLAIM_ON_BATCH: "released claim on batch",
    BATCH_ASSIGNED: "assigned batch to",
    REMOVED_BATCH_ASSIGNMENT: "removed assigned moderator",
    MARKED_BATCH_AS_COMPLETE: "marked batch as complete",
    SET_GEM_STATUS_TO_TRUE: "set starred (heart) to True",
    SET_GEM_STATUS_TO_FALSE: "set starred (heart) to False",
    SET_EXPLICIT_STATUS_TO_FALSE: "set manual_adult_content_advised to False",
    SET_NEEDS_RELEASE_STATUS_TO_FALSE:
        "set has_recognizable_people_or_property to False",
    SET_EDITORIAL_USE_ONLY_TO_FALSE: "set editorial_use_only to False",
    SET_HAS_WARNING_TEXT_TO_FALSE: "set manual_warning_text to False",
    SET_MATURE_TO_TRUE: "set mature to True",
    SET_MATURE_TO_FALSE: "set mature to False"
};
